function headerAlert(header, isFixed) {
  const alert = header.querySelector('.alert-block');

  if (alert && isFixed) {
    document.body.style.paddingTop = `${header.offsetHeight}px`;
  }
}

function headerSearch(header) {
  const hiddenClass = 'hidden';
  const closeClass = 'collapsed';
  const showButton = header.querySelector('.show-search-button');
  const closeButton = header.querySelector('.close-search-button');
  const searchNav = header.querySelector('.search-nav');
  const searchInput = searchNav.querySelector('.search-input');
  const submitButton = searchNav.querySelector('.submit-search-button');

  if (searchNav) {
    searchNav.addEventListener('transitionend', (event) => {
      if (searchNav.classList.contains(closeClass)) {
        searchNav.classList.add(hiddenClass);
      }
    });

    // Show search form, add tabindex and hide body scroll
    showButton.addEventListener('click', (event) => {
      searchInput.focus();
      searchNav.classList.remove(hiddenClass);
      searchNav.classList.remove(closeClass);
      document.body.style.overflow = 'hidden';
    });

    // Hide search form, remove tabindex and show body scroll
    closeButton.addEventListener('click', (event) => {
      searchNav.classList.add(closeClass);
      document.body.style.overflow = 'visible';
    });
  }
}

function hideSecondaryNav(header) {
  const secondaryNav = header.querySelector('.secondary-nav-container');
  const alertBlock = header.querySelector('.alert-block:not(.hidden)');

  if (secondaryNav && !alertBlock) {
    window.addEventListener('scroll', (event) => {
      if (window.pageYOffset > 200 && window.innerWidth > 991) {
        header.style.transform = 'translateY(' + secondaryNav.clientHeight * -1 + 'px)';
      } else {
        header.style.transform = 'none';
      }
    });
  }
}

function desktopMenu(header) {
  const nav = header.querySelector('.primary-nav-container .primary-nav');

  if (nav) {
    const hiddenClass = 'hidden';
    const closeClass = 'collapsed';
    const subMenuParents = nav.querySelectorAll('.menu-item-has-children > .desktop-submenu-parent');
    const subMenus = [...nav.querySelectorAll('.desktop-submenu')];

    // Hide submenus when transition ends to avoid tab focus.
    subMenus.forEach((subMenu) => {
      subMenu.addEventListener('transitionend', (event) => {
        if (subMenu.classList.contains(closeClass)) {
          subMenu.classList.add(hiddenClass);
        }
      });
    });

    // Hide submenus when a click happens anywhere but the submenu parent.
    document.body.addEventListener('click', (event) => {
      const isSubMenuParent = event.target.classList.contains('desktop-submenu-parent');
      const openSubMenu = subMenus.find(submenu => !submenu.classList.contains(hiddenClass));
      const isSubMenuChildren = openSubMenu && openSubMenu.contains(event.target);

      if (!isSubMenuParent && !isSubMenuChildren) {
        subMenus.forEach((subMenu) => {
          subMenu.classList.add(closeClass);
        });
      }
    });

    // Display submenu when parent menu is clicked.
    subMenuParents.forEach((menu) => {
      menu.addEventListener('click', (event) => {
        event.preventDefault();
        const subMenuId = event.target.hash.split('#').pop();
        const subMenu = subMenus.find(item => item.id === subMenuId);

        // Close all submenus before opening one.
        subMenus.forEach((subMenu) => {
          subMenu.classList.add(closeClass);
        });

        // Open submenu.
        if (subMenu) {
          // Add body padding since there could be an alert open.
          if (document.body.style.paddingTop) {
            subMenu.style.top = document.body.style.paddingTop;
          }

          subMenu.classList.remove(hiddenClass);
          subMenu.classList.remove(closeClass);
        }
      });
    });
  }
}

function mobileMenu(header) {
  const menuContainer = header.querySelector('.mobile-menu');

  if (menuContainer) {
    let backButtonHistory = [];
    const hiddenClass = 'hidden';
    const closeClass = 'collapsed';
    const backButton = menuContainer.querySelector('.back-button');
    const openButton = header.querySelector('.open-menu-button');
    const closeButton = menuContainer.querySelector('.close-menu-button');
    const openSubMenuButtons = menuContainer.querySelectorAll('.menu-item-has-children > a');
    const defaultMenu = menuContainer.querySelector('.default-nav');
    const subMenus = [...menuContainer.querySelectorAll('.second-level-nav, .third-level-nav')];


    menuContainer.addEventListener('transitionend', (event) => {
      if (menuContainer.classList.contains(closeClass)) {
        menuContainer.classList.add(hiddenClass);
      }
    });

    subMenus.forEach((subMenu) => {
      subMenu.addEventListener('transitionend', (event) => {
        if (subMenu.classList.contains(closeClass)) {
          subMenu.classList.add(hiddenClass);
        } else {
          // Hide other menus so they can't be focused.
          defaultMenu.classList.add(hiddenClass);
          subMenus.forEach((otherSubMenu) => {
            if (otherSubMenu.id !== subMenu.id) {
              otherSubMenu.classList.add(hiddenClass);
            }
          });
        }
      });
    });

    openButton.addEventListener('click', (event) => {
      document.body.style.overflow = 'hidden';
      menuContainer.classList.remove(hiddenClass);
      menuContainer.classList.remove(closeClass);
    });

    closeButton.addEventListener('click', (event) => {
      document.body.style.overflow = '';

      // Clear and hide back button.
      backButtonHistory = [];
      backButton.classList.add(hiddenClass);

      // Close menu and reset submenus.
      menuContainer.classList.add(closeClass);
      subMenus.forEach(function(subMenu) {
        subMenu.classList.add(closeClass);
      });
    });

    backButton.addEventListener('click', (event) => {
      const closeMenuId = backButtonHistory.pop();
      const closeMenu = closeMenuId && subMenus.find(item => item.id === closeMenuId);
      const prevMenuId = backButtonHistory[backButtonHistory.length - 1];
      const prevMenu = prevMenuId && subMenus.find(item => item.id === prevMenuId);

      if (closeMenu) {
        closeMenu.classList.add(closeClass);
      }

      if (prevMenu) {
        prevMenu.classList.remove(hiddenClass);
      } else {
        defaultMenu.classList.remove(hiddenClass);
      }

      if (!backButtonHistory.length) {
        backButton.classList.add(hiddenClass);
      }
    });

    openSubMenuButtons.forEach(function(button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const subMenuId = event.target.hash.split('#').pop();
        const subMenu = subMenus.find(item => item.id === subMenuId);

        if (subMenu) {
          backButton.classList.remove(hiddenClass);
          backButtonHistory.push(subMenuId);

          subMenu.classList.remove(hiddenClass);
          subMenu.classList.remove(closeClass);
        }
      });
    });
  }
}

export function headerAlertClosed() {
  const header = document.querySelector('#header');
  const isFixed = document.body.classList.contains('header-fixed');

  if (isFixed) {
    document.body.style.paddingTop = `${header.offsetHeight}px`;
  }
}

function showCallButton() {
  const button = document.querySelector('.floating-call-button');

  if (button) {
    window.addEventListener('scroll', (event) => {
      if (window.pageYOffset > 200) {
        button.classList.add('scrolled');
      } else {
        button.classList.remove('scrolled');
      }
    });
  }
}

export function headerInit() {
  const header = document.querySelector('#header');
  const isFixed = document.body.classList.contains('header-fixed');

  if (header) {
    headerAlert(header, isFixed);
    headerSearch(header);
    desktopMenu(header);
    mobileMenu(header);
    hideSecondaryNav(header);
  }

  showCallButton();

  window.addEventListener('resize', (event) => {
    headerAlert(header, isFixed);
  });
}



// WEBPACK FOOTER //
// ./src/js/header.js